"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var Modal_1 = __importDefault(require("../../../../common/Modal/Modal"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var Mutation_1 = require("../Graphql/Mutation");
var Queries_1 = require("../Graphql/Queries");
var AddMonitoringCategoryForm_1 = __importDefault(require("./AddMonitoringCategoryForm"));
var MonitoringCategory = function (_a) {
    var list = _a.list;
    var organization = (0, org_hook_1.useOrg)().organization, _b = (0, react_i18next_1.useTranslation)(), i18n = _b.i18n, t = _b.t, _c = (0, react_1.useState)([
        {
            id: null,
            name: {},
            sorting: null,
            organization_id: null,
        },
    ]), fields = _c[0], setFields = _c[1], _d = (0, react_1.useState)([]), error = _d[0], setError = _d[1];
    var _e = (0, client_1.useMutation)(Mutation_1.UPSERT_MONITORING_CATEGORY, {
        fetchPolicy: "network-only",
        refetchQueries: [Queries_1.GET_MONITORING_CATEGORY, "getMonitoringCategory"],
    }), callUpsertMonitoringCategory = _e[0], upsertMonitoringCategoryResponse = _e[1];
    var triggerButton = function () {
        react_1.default.createElement("div", { className: "absoulte-buttom", style: { top: "8.3rem" } },
            react_1.default.createElement(Button_1.default, { className: "form-buttom", icon: react_1.default.createElement(icons_1.default, { name: "plus", className: "icon", height: 30, width: 30 }), text: t("add_category") }));
    };
    function handleChange(i, value, type) {
        setError([]);
        var values = __spreadArray([], fields, true);
        if (type === "name") {
            values[i][type][i18n.language] = value;
        }
        else if (type === "sorting") {
            values[i][type] = value;
        }
        else {
            values[i][type] = value;
        }
        setFields(values);
    }
    var arrLength = fields.length - 1, addTextInput = function () {
        var values = __spreadArray([], fields, true);
        values.push({
            id: null,
            name: {
                en: "",
                fr: "",
                rn: "",
            },
            sorting: null,
            organization_id: organization.id,
        });
        setFields(values);
    }, removeTextInput = function (i) {
        var values = __spreadArray([], fields, true);
        values.splice(i, 1);
        setFields(values);
    };
    var createUI = function () {
        react_1.default.createElement(react_1.default.Fragment, null, fields.map(function (item, idx) {
            var _a;
            var findIndex = error.length > 0 &&
                error.find(function (i) { return i.index === idx; });
            return (react_1.default.createElement(react_1.Fragment, { key: idx },
                react_1.default.createElement(AddMonitoringCategoryForm_1.default, { idx: idx, arrLength: arrLength, handleChange: handleChange, error: findIndex &&
                        findIndex.index === idx &&
                        findIndex.type === "name" &&
                        findIndex.message, nameValue: (_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a[i18n.language], sortValue: item.sorting, addTextInput: function () { return addTextInput(); }, removeTextInput: function (i) { return removeTextInput(i); }, sortingList: list })));
        }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal_1.default, { onCloseClick: function () {
                // resetForm();
            }, onSaveClick: function () { }, title: t("add_monitoring_category"), triggerButton: triggerButton() },
            react_1.default.createElement(react_1.default.Fragment, null,
                " ",
                createUI()))));
};
exports.default = MonitoringCategory;
